import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PromotionMessageService} from '../../../services/promotion/promotion-message.service';
import {PromotionMessageModel} from '../../../models/promotion-message.model';
import {PromotionWizardService} from '../../../services/promotion/promotion-wizard.service';
import {TranslateService} from '@ngx-translate/core';
import {PromotionDiscountTypeService} from '../../../services/promotion/promotion-discount-type.service';
import {PromotionMessageTypeService} from '../../../services/promotion/promotion-message-type.service';
import {LoyaltyParamsService} from '../../../services/loyalty/params.service';
import {LoyaltyClusterService} from '../../../services/loyalty/loyalty-cluster.service';
import {PromotionTemplateService} from '../../../services/promotion/promotion-template.service';
import {PromotionMessageLayoutService} from '../../../services/promotion/promotion-message-layout.service';
import {PromotionTouchPointService} from '../../../services/promotion/promotion-touch-point.service';
import {PromotionLayoutService} from '../../../services/promotion/promotion-layout.service';
import {KontableComponent} from '../../../modules/UIKit/components/kontable/kontable.component';

@Component({
  selector: 'kv-promo-message',
  template: `
    <app-kontable
      title="{{ 'promotion.messagesTitle' | translate }}"
      *ngIf="!show"
      [columns]="[
        'id',
        'code',
        'type_message_id',
        'description'
      ]"
      [titles]="[
        '#',
        'promotion.code',
        'promotion.typeMessage',
        'promotion.description'
      ]"
      [service]="svcMessage"
      [paginationType]="paginationType"
      [showInfoButton]="true"
      [showRecoverButton]="false"
      [showDetailsButton]="false"
      [showAddButton]="true"
      [showGlobalFilter]="false"
      (onAdd)="showAdd()"
      (onEdit)="showEdit($event)"
      (onRemove)="delete($event)"
      [name]="'promotion.messageTable'">
    </app-kontable>
    <kv-promo-message-detail
      *ngIf="show"
      [shortInsert]="shortInsert"
      [titlePage]="titlePage"
      (hide)="editMessage = null; toggleShow()"
      [wizards]="wizards"
      [discountTypes]="discountTypes"
      [messagesTypes]="messagesTypes"
      [barCodes]="barCodes"
      [clusters]="clusters"
      [templates]="templates"
      [editMessage]="editMessage"
      [touchPoints]="touchPoints"
      [layouts]="layouts">
    </kv-promo-message-detail>
  `
})
export class MessageComponent implements OnInit {

  @Input() shortInsert: false;
  @Output() shortInsertCompleted = new EventEmitter();

  messages: PromotionMessageModel[];
  editMessage: PromotionMessageModel = null;
  paginationType = KontableComponent.ServerPagination;
  show = false;
  titlePage = '';

  wizards;
  discountTypes;
  messagesTypes;
  barCodes;
  clusters;
  templates;
  layouts;
  touchPoints;

  chooseWizard;
  chooseDiscount;
  chooseMessage;
  chooseBarCode;
  chooseCluster;
  chooseTemplate;
  chooseTouchPoint;
  chooseLayout;

  constructor(private svcMessage: PromotionMessageService,
              private svcWizard: PromotionWizardService,
              private srvTranslate: TranslateService,
              private svcDiscountType: PromotionDiscountTypeService,
              private svcMessageType: PromotionMessageTypeService,
              private svcParams: LoyaltyParamsService,
              private svcCluster: LoyaltyClusterService,
              private svcTemplate: PromotionTemplateService,
              private svcMessageLayout: PromotionMessageLayoutService,
              private svcTouchPoint: PromotionTouchPointService,
              private svcLayout: PromotionLayoutService
              ) {
    this.srvTranslate.get(['promotion.chooseWizard']).subscribe((res) => {
      this.chooseWizard = res['promotion.chooseWizard']
    });
    this.srvTranslate.get(['promotion.chooseDiscount']).subscribe((res) => {
      this.chooseDiscount = res['promotion.chooseDiscount']
    });
    this.srvTranslate.get(['promotion.chooseMessage']).subscribe((res) => {
      this.chooseMessage = res['promotion.chooseMessage']
    });
    this.srvTranslate.get(['promotion.chooseBarCode']).subscribe((res) => {
      this.chooseBarCode = res['promotion.chooseBarCode']
    });
    this.srvTranslate.get(['promotion.chooseCluster']).subscribe((res) => {
      this.chooseCluster = res['promotion.chooseCluster']
    });
    this.srvTranslate.get(['promotion.chooseTemplate']).subscribe((res) => {
      this.chooseTemplate = res['promotion.chooseTemplate']
    });
    this.srvTranslate.get(['promotion.chooseTouchPoint']).subscribe((res) => {
      this.chooseTouchPoint = res['promotion.chooseTouchPoint']
    });
    this.srvTranslate.get(['promotion.chooseLayout']).subscribe((res) => {
      this.chooseLayout = res['promotion.chooseLayout']
    });
    svcWizard.list(0, 999999, [
      {
        key: 'type',
        value: 'message'
      }
    ]).subscribe(res => {
      this.wizards = [{label: this.chooseWizard, value: null}];
      for (let elem of res.data) {
        this.wizards.push({
          label: elem.code + ' - ' + elem.description,
          value: elem.id
        })
      }
    });
    svcDiscountType.list(0, 999999).subscribe( (res) => {
      this.discountTypes = [{label: this.chooseDiscount, value: null}];
      for (let elem of res.data) {
        this.discountTypes.push({
          label: elem.code + ' - ' + elem.description,
          value: elem.id
        })
      }
    });
    svcLayout.list(0, 999999).subscribe( (res) => {
      this.layouts = [{label: this.chooseLayout, value: null}];
      for (let elem of res.data) {
        this.layouts.push({
          label: elem.code + ' - ' + elem.description,
          value: elem.id
        })
      }
    });
    this.svcTouchPoint.list(0, 999999).subscribe( (res) => {
      this.touchPoints = [{label: this.chooseTouchPoint, value: null}];
      for (let elem of res.data) {
        this.touchPoints.push({
          label: elem.code + ' - ' + elem.description,
          value: elem.id
        })
      }
    });
    svcMessageType.list(0, 999999).subscribe( (res) => {
      this.messagesTypes = [{label: this.chooseMessage, value: null}];
      for (let elem of res.data) {
        this.messagesTypes.push({
          label: elem.code + ' - ' + elem.description,
          value: elem.id
        })
      }
    });
    svcCluster.list(0, 999999).subscribe( (res) => {
      this.clusters = [{label: this.chooseCluster, value: null}];
      for (let elem of res.data) {
        this.clusters.push({
          label: elem.cluster_type_code + ' - ' + elem.description,
          value: elem.id
        })
      }
    });
    svcTemplate.list(0, 999999).subscribe( (res) => {
      this.templates = [{label: this.chooseTemplate, value: null}];
      for (let elem of res.data) {
        this.templates.push({
          label: elem.code + ' - ' + elem.description,
          value: elem.id
        })
      }
    });
    this.svcParams.list(0, 999999, [
        {
          key: 'param_group',
          value: 'MessageBarCodeType'
        }
      ]
    ).subscribe(p => {
      this.barCodes = [{label: this.chooseBarCode, value: null}];
      for (let elem of p.data) {
        this.barCodes.push({
          label: elem.description,
          value: elem.id
        })
      }
    });
  }

  ngOnInit(): void {
    if (this.shortInsert) {
      this.showAdd();
    }
  }

  delete(item: any) {
    this.svcMessage.delete(item.id).subscribe( () => {
      KontableComponent.signalDataChange.emit({name: 'promotion.messageTable', method: 'delete'});
    });
  }

  showEdit(item) {
    this.titlePage = 'promotion.editMessage';
    this.svcMessage.get(item.id).subscribe((res) => {
      this.editMessage = res;
        this.toggleShow();
    });
  }

  showAdd() {
    this.titlePage = 'promotion.addMessage';
    this.toggleShow()
  }

  toggleShow() {
    this.show = !this.show
  }

  // FIXME: la kontable prendere correttamente in input il service in questo modo:
  //  [service]="svcCampaign" e [paginationType]="paginationType" ma a seguito ad esempio
  //  di una semplice delete, chiamata con this.svcCampaign.delete(id).subscribe() la
  //  kontable non viene aggiornata in automatico

}



// WEBPACK FOOTER //
// ./src/app/views/promotion/message/message.component.ts